import {
    type AdminLoginResponseType,
    type AdminLoginRequestType
} from "./type";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
    SERVER_ADDRESS
} from "../../constants";

const AdminLogin = async (params: AdminLoginRequestType): Promise<AdminLoginResponseType> => {
    const response = await fetch(`${SERVER_ADDRESS}/auth/adminLogin`, {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(params),
        method: "POST"
    });

    const data = await response.json() as AdminLoginResponseType;

    if(!response.ok) {
        throw data;
    }

    if(data.payload?.accessToken) {
        await AsyncStorage.setItem("authToken", data.payload.accessToken);
        await AsyncStorage.setItem("authRefreshToken", data.payload.refreshToken);
    }

    return data;
};

export default AdminLogin;
